export enum MOBILE_SUBDOMAIN_ENDPOINTS {
  PRODUCTION = 'https://mobile.wetransfer.com',
  STAGING = 'https://mobile.wetransferbeta.com',
}
